import { Box } from "@mui/material";
import React from "react";

interface PengaturanTabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const PengaturanTabPanel = ({
    children,
    value,
    index,
}: PengaturanTabPanelProps) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`pengaturan-tabpanel-${index}`}
            aria-labelledby={`pengaturan-tab-${index}`}
        >
            {value === index && <Box sx={{ paddingY: 3 }}>{children}</Box>}
        </div>
    );
};

export const getPengaturanTabA11yProps = (index: number) => ({
    id: `pengaturan-tab-${index}`,
    "aria-controls": `pengaturan-tabpanel-${index}`,
});

export default PengaturanTabPanel;
